import { FALLBACK_LOCALE, SupportedLocale } from './config';
import type { MessageMap } from './loader';

/**
 * Translation function for non-React contexts (action handlers, toast callers, axios error
 * catches). React components should prefer <FormattedMessage> or useIntl() so react-intl
 * handles ICU parsing, gender, and plural rules. This helper only supports simple
 * {placeholder} substitution — do NOT use it for plural/select messages.
 *
 * I18nProvider keeps the runtime snapshot in sync via setRuntimeMessages().
 */

let currentLocale: SupportedLocale = FALLBACK_LOCALE;
let currentMessages: MessageMap = {};

export function setRuntimeMessages(locale: SupportedLocale, messages: MessageMap): void {
    currentLocale = locale;
    currentMessages = messages;
}

export function getRuntimeLocale(): SupportedLocale {
    return currentLocale;
}

export function t(id: string, params?: Record<string, string | number>): string {
    const template = currentMessages[id] ?? id;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (_, key) => {
        const val = params[key];
        return val === undefined ? `{${key}}` : String(val);
    });
}
